import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cx(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Formats image URL for blog posts
 * If the URL is an S3 URL, it wraps it in the media view API endpoint
 * @param imageUrl - The image URL from the API
 * @returns Formatted image URL
 */
export function formatBlogImageUrl(imageUrl: string | undefined | null): string {
  if (!imageUrl) {
    return 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=80';
  }

  // If it's already a media view URL, return as is
  if (imageUrl.includes('/media/view?')) {
    return imageUrl;
  }

  // If it's an S3 URL, wrap it in the media view API
  if (
    imageUrl.includes('vxfx-io.s3.eu-central-1.amazonaws.com') ||
    imageUrl.includes('s3.eu-central-1.amazonaws.com')
  ) {
    const encodedUrl = encodeURIComponent(imageUrl);
    return `https://api.vxfx.io/media/view?url=${encodedUrl}`;
  }

  // If it's a direct API file path (like /1733110794800_xxx.webp or https://api.vxfx.io/1733110794800_xxx.webp)
  // These need to be wrapped in /media/view endpoint for Next.js Image to work
  if (
    (imageUrl.startsWith('http') &&
      imageUrl.includes('api.vxfx.io') &&
      !imageUrl.includes('/media/view')) ||
    (imageUrl.startsWith('/') &&
      imageUrl.match(/\/\d+_[a-f0-9]+\.(jpg|jpeg|png|gif|webp|svg|avif)$/i))
  ) {
    // If it's a relative path, make it absolute
    const absoluteUrl = imageUrl.startsWith('http') ? imageUrl : `https://api.vxfx.io${imageUrl}`;
    const encodedUrl = encodeURIComponent(absoluteUrl);
    return `https://api.vxfx.io/media/view?url=${encodedUrl}`;
  }

  // For other URLs (like unsplash), return as is
  return imageUrl;
}
